import { render, staticRenderFns } from "./jincangQueren.vue?vue&type=template&id=abd48eba&scoped=true&"
import script from "./jincangQueren.vue?vue&type=script&lang=js&"
export * from "./jincangQueren.vue?vue&type=script&lang=js&"
import style0 from "./jincangQueren.vue?vue&type=style&index=0&id=abd48eba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd48eba",
  null
  
)

export default component.exports